export default __webpack_public_path__ + "static/media/animal-2.3cbc9f33.svg";